import { AppState } from "../../../redux/reducers";

// store
import * as ContractConceptRelationShipStore from "../../../redux/middleware/ContractConceptRelationship.Middleware";
import * as ContractConceptStore from "../../../redux/middleware/ContractConceptMiddleware";
import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";
import { ContractConcept } from "../../../models/Entities/Contracts/ContractConcept";
import { Contract } from "../../../models/Entities/Contracts/Contract";
import { ErrorType } from "../../../models/HttpError";

interface IProps {
  ContractId: number;
}

interface ConnectedProps {
  isLoading: boolean;
  LoadingSuccess: boolean;
  failLoading: boolean;
  error: ErrorType | undefined;
  concepts: ContractConceptRelationship[];
  contractConcepts: ContractConcept[];
  isDeleting?: boolean;
  successDeleting?: boolean;
}

interface ComponentDispatchProps {
    getAllContractConceptRelationships: typeof ContractConceptRelationShipStore.actionCreators.getAllContractConceptRelationships;
    createContractConceptRelationship: typeof ContractConceptRelationShipStore.actionCreators.createContractConceptRelationship;
    deleteContractConceptRelationship: typeof ContractConceptRelationShipStore.actionCreators.deleteContractConceptRelationship;
    GetAllContractsConcept: typeof ContractConceptStore.actionCreators.GetAllContractsConcept;
}

export type Props = IProps & ConnectedProps & ComponentDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.ContractConceptRelationship?.isLoadingAll ?? false,
    LoadingSuccess: state.ContractConceptRelationship?.successLoadingAll ?? false,
    failLoading: state.ContractConceptRelationship?.failOnLoadingAll ?? false,
    error: state.ContractConceptRelationship?.error,
  concepts: state.ContractConceptRelationship?.list ?? [],
  contractConcepts: (() => {
      const fromContract = (state.Contract?.list ?? []).find((c: Contract) => c.id === ownProps.ContractId)?.concepts ?? [];
      const fromStore = state.ContractConcept?.list ?? [];
      const byId = new Map<number, ContractConcept>();
      fromStore.forEach((c: ContractConcept) => byId.set(c.id, c));
      fromContract.forEach((c: ContractConcept) => byId.set(c.id, c));
      return Array.from(byId.values());
  })(),
  isDeleting: state.ContractConceptRelationship?.isDeletingOne ?? false,
  successDeleting: state.ContractConceptRelationship?.successDeletingOne ?? false,
    
});

export const mapDispatchToProps = {
  ...ContractConceptRelationShipStore.actionCreators,
  GetAllContractsConcept: ContractConceptStore.actionCreators.GetAllContractsConcept,
};